export const searchWebhookSuggestionsDictionary: Partial<Record<WebhookSuggestions, string>> = {
  label: "labels",
};

export enum WebhookSuggestions {
  Label = "label",
  Space = "space",
}
